<script setup>
import UserForm from './Forms/UserForm.vue';
</script>
<template>
	<div class="user-section">
		<UserForm />
	</div>
</template>
<style lang='scss'>
.user-section {
	width: 100%;
	padding-bottom: 100px;

	@include mq(560px) { padding-bottom: 0 }
}
</style>